import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { LeftOutlined, UnorderedListOutlined, PlusCircleOutlined, UserOutlined } from "@ant-design/icons";

const ROUTE_TITLES: Record<string, string> = {
  "/": "Mẫu đã tạo",
  "/create": "Cấu hình chip",
  "/profile": "Cá nhân",
  "/verify": "Quét mã",
  "/login": "Đăng nhập",
  "/not-found": "404",
};

const BOTTOM_TABS = [
  { key: "/", label: "Danh sách", icon: <UnorderedListOutlined /> },
  { key: "/create", label: "Tạo mới", icon: <PlusCircleOutlined /> },
  { key: "/profile", label: "Cá nhân", icon: <UserOutlined /> },
];

const HIDE_SHELL_ROUTES = ["/login", "/verify", "/not-found", "/scan", "/view", "/scan-error", "/not-configured"];

export default function MobileLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const pageTitle = ROUTE_TITLES[location.pathname] ?? "Smart Gift";
  const showShell = !HIDE_SHELL_ROUTES.includes(location.pathname);
  const canGoBack = location.pathname !== "/" && showShell;

  return (
    <div className="mx-auto flex h-dvh max-w-190 flex-col bg-white">
      {/* Header */}
      {showShell && (
        <header className="relative flex h-12 shrink-0 items-center border-b border-gray-200 bg-white px-4">
          {canGoBack && (
            <Button type="text" icon={<LeftOutlined />} onClick={() => navigate(-1)} className="absolute text-base!" />
          )}
          <h1 className={`text-base font-semibold ${canGoBack ? "ml-3" : ""}`}>{pageTitle}</h1>
        </header>
      )}

      {/* Content */}
      <main className="flex-1 overflow-y-auto bg-[#F4F5F6]">
        <Outlet />
      </main>

      {/* Bottom Navigation */}
      {showShell && (
        <nav className="flex h-14 shrink-0 items-center border-t border-gray-200 bg-white">
          {BOTTOM_TABS.map((tab) => {
            const isActive = location.pathname === tab.key;
            return (
              <button
                key={tab.key}
                onClick={() => navigate(tab.key)}
                className={`flex flex-1 flex-col items-center gap-0.5 border-none bg-transparent py-1 ${
                  isActive ? "text-blue-500" : "text-gray-400"
                }`}
              >
                <span className="text-xl">{tab.icon}</span>
                <span className="text-xs">{tab.label}</span>
              </button>
            );
          })}
        </nav>
      )}
    </div>
  );
}
